import { VizState } from '@cubejs-client/react';
import { Chart } from '@threatadvisor/react-components';
import { Typography } from 'antd';
import React, { ReactElement } from 'react';

type StatusReportParams = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
  securityEventApi: string;
};

export default function EventsByAlertType(props: StatusReportParams): ReactElement {
  const { clientUid, reportStart, reportEnd, securityEventApi } = props;

  const chartConfig: VizState = {
    chartType: 'bar',
    pivotConfig: {
      x: ['security_event.name'],
      y: ['measures'],
      fillMissingDates: true
      //joinDateRange: false
    },
    query: {
      measures: ['security_event.count'],
      order: {
        'security_event.count': 'desc'
      },
      dimensions: ['security_event.name'],
      timeDimensions: [
        {
          dimension: 'security_event.createdDate',
          dateRange: [reportStart, reportEnd]
        }
      ],
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        }
      ],
      limit: 20
    }
  };

  return (
    <>
      <h2 className="text-uppercase">Top Event Types</h2>
      <figure>
        <Chart
          wrapCategoryAxisLabel
          noTitleTranslation
          useHeightBasedOnHowManyItems
          chartConfig={{
            legend: false
          }}
          config={chartConfig}
        />
        <figcaption>
          <Typography.Text type="secondary">Shows events received by alert type.</Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
